import styled from 'styled-components';
import { TabListMixin } from '../../mixins/components/TabListMixin';
import { ToggleButtonGroup } from '../ToggleButtonGroup/ToggleButtonGroup';
export var StyledTabList = /*#__PURE__*/styled(ToggleButtonGroup).withConfig({
  displayName: "StyledTabList",
  componentId: "c11n-8-107-0__sc-12d5wpo-0"
})(["", ""], TabListMixin);